// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HrynP","colBig":"styles_colBig__2MNzc","colSmall":"styles_colSmall__3Ckw0","shopifyNameWrapper":"styles_shopifyNameWrapper__3yGQr"};